export default {
  name: "conditionSection",
  methods: {
    directionClass() {
      if (this.$store.state.locale == 'ar') return 'directionRight'
      else return 'directionLeft'
    }
  }
};
